import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import Typography from '../Typography';
import { IStyleWrapper, StyledLoadingWithBackdrop } from './loadingWithBackdrop.style';

export interface ILoadingWithBackdropProps {
  isOpen: boolean;
  handleClose?: () => void;
  percentage?: number;
  loadingText?: string;
  children?: React.ReactNode;
  stylewrapper?: IStyleWrapper;
}

const LoadingWithBackdrop = (props: ILoadingWithBackdropProps) => {
  const { isOpen, handleClose, percentage, loadingText, children, stylewrapper } = props;

  return (
    <StyledLoadingWithBackdrop open={isOpen} onClick={handleClose} stylewrapper={stylewrapper}>
      {!!children ? (
        children
      ) : (
        <>
          {percentage ? (
            <Box className="wrapper">
              <CircularProgress
                className="circular"
                variant="determinate"
                value={Math.round(percentage)}
              />

              <Box className="percentage">
                <Typography kind="caption" as="div">
                  {`${Math.round(percentage)}%`}
                </Typography>
              </Box>
            </Box>
          ) : (
            <CircularProgress className="circular" />
          )}
          {loadingText && (
            <Typography kind="caption" as="div" className="message">
              {loadingText}
            </Typography>
          )}
        </>
      )}
    </StyledLoadingWithBackdrop>
  );
};

export const defaultProps = {
  isOpen: true,
  handleClose: () => {},
  percentage: 0,
  loadingText: '',
  children: '',
  stylewrapper: {},
};
LoadingWithBackdrop.defaultProps = defaultProps;

export default LoadingWithBackdrop;
